import { AssetConfig } from "../index";

export const SupplierAssetConfig: AssetConfig = {
    name: {type: "STRING",required: true,editable: true,label: "Name",rank: 1},
    isActive: {type: "BOOLEAN",required: true,editable: true,label: "Active",rank: 2},
}